import { render, staticRenderFns } from "./dialog-add-personnel.vue?vue&type=template&id=3480bcfd&scoped=true&"
import script from "./dialog-add-personnel.vue?vue&type=script&lang=js&"
export * from "./dialog-add-personnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3480bcfd",
  null
  
)

export default component.exports